module.exports = __webpack_public_path__ + "static/media/whiteGoBack.48c92547.svg";